<template>
  <div class="inputGai">
    <el-date-picker
      v-model="innerValue[0]"
      :format="renderConfig.format"
      :placeholder="renderConfig.placeholder"
      :disabled="renderConfig.disabled"
      :valueFormat="renderConfig.valueFormat"
      style="flex-grow: 1; width: 100%"
      @change="handleChange"
    />
    <span class="separate">-</span>
    <el-date-picker
      v-model="innerValue[1]"
      :format="renderConfig.format"
      :placeholder="renderConfig.placeholder"
      :disabled="renderConfig.disabled"
      :valueFormat="renderConfig.valueFormat"
      :shortcuts="renderConfig.shortcuts"
      style="flex-grow: 1; width: 100%"
      @change="handleChange"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, unref } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'blur'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    console.log(newVal, 1111)
    emit('update:modelValue', newVal)
  }
})
function handleChange(e: string[]) {
  console.log(e, '123')

  emit('update:modelValue', innerValue.value)
  emit('blur', unref)
}
</script>
<style lang="scss" scoped>
.inputGai {
  display: flex;
  align-items: center;
  .separate {
    padding: 0 4px;
  }
}
</style>
